import { Box, IconButton, Modal, SelectChangeEvent, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { MouseEvent } from 'react';
import {
	closeButtonSX,
	contentSX,
	descriptionHighlightSX,
	descriptionSX,
	dialogContainerSX,
	modalRootSX,
	modalSX,
	titleSX,
} from '@/components/blocks/FreeShippingActivatedPopup/styles';
import { FreeShippingPopupActions } from '@/components/blocks/FreeShippingActivatedPopup/parts/FreeShippingPopupActions';
import { FreeShippingProductCard } from '@/components/blocks/FreeShippingActivatedPopup/parts/FreeShippingProductCard';
import { HighlightedText } from '@/components/blocks/HighlightedText';
import {
	FreeShippingProductHref,
	FreeShippingProductInfo,
} from '@/components/blocks/FreeShippingActivatedPopup/parts/types';

interface FreeShippingActivatedPopupDialogProps {
	open: boolean;
	title?: string;
	description?: string;
	productInfo: FreeShippingProductInfo;
	productSelected?: string;
	productHref?: FreeShippingProductHref;
	hideSizeSelect?: boolean;
	onClosePopup: () => void;
	onSelectProductSize: (event: SelectChangeEvent<string>) => void;
	onAddToCart: (event: MouseEvent<HTMLButtonElement>) => void;
	onViewProduct?: () => void;
}

export const FreeShippingActivatedPopupDialog = ({
	open,
	title,
	description,
	productInfo,
	productSelected,
	productHref,
	hideSizeSelect,
	onClosePopup,
	onSelectProductSize,
	onAddToCart,
	onViewProduct,
}: FreeShippingActivatedPopupDialogProps) =>
	open ? (
		<Modal
			slotProps={{
				root: {
					sx: modalRootSX,
				} as any,
			}}
			sx={modalSX}
			open={open}
			onClose={onClosePopup}
		>
			<Box sx={dialogContainerSX}>
				<IconButton color="inherit" onClick={onClosePopup} sx={closeButtonSX} aria-label="Cerrar">
					<ClearIcon color="inherit" fontSize="inherit" />
				</IconButton>

				<Box sx={contentSX}>
					<Typography component="h2" sx={titleSX}>
						{title}
					</Typography>
					<Typography sx={descriptionSX}>
						<HighlightedText text={description} sx={descriptionHighlightSX} component="span" />
					</Typography>

					<FreeShippingProductCard
						productInfo={productInfo}
						productSelected={productSelected}
						productHref={productHref}
						hideSizeSelect={hideSizeSelect}
						onSelectProductSize={onSelectProductSize}
						onViewProduct={onViewProduct}
					/>

					<FreeShippingPopupActions onAddToCart={onAddToCart} onClosePopup={onClosePopup} />
				</Box>
			</Box>
		</Modal>
	) : null;
